import React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import styled from '../styled';
import { Tooltip } from 'antd';
import { floor } from 'lodash';
const { mlr4 } = styled;

const PanelExtraTemplate = ({ threshold = null, value = null }) => {
  return (
    <div style={{ display: 'flex' }} className="widgitsView">
      <b>Threshold :</b>
      <Tooltip title={threshold}>
        <span style={mlr4}>{floor(threshold, 2)}</span>
      </Tooltip>
      <b>Values :</b>
      <Tooltip title={value}>
        <span style={mlr4}>{floor(value, 2)}</span>
      </Tooltip>
      {threshold < value && <ArrowUpOutlined style={{ color: 'red' }} />}
      {threshold > value && <ArrowDownOutlined style={{ color: 'navy' }} />}
    </div>
  );
};
export default PanelExtraTemplate;
